export function embeddedInParent(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.parent !== window) return true;
  try {
    return new URLSearchParams(window.location.search).get('tl4k-embedded') === '1';
  } catch {
    return false;
  }
}

export function isTl4kEmbedded(search: string = typeof window !== 'undefined' ? window.location.search : ''): boolean {
  const params = new URLSearchParams(search);
  return params.get('tl4k-embedded') === '1';
}

export function postTl4kGoBack(targetOrigin = '*'): boolean {
  if (!isTl4kEmbedded() || !embeddedInParent()) return false;
  window.parent.postMessage({ type: 'TL4K_GO_BACK' }, targetOrigin);
  return true;
}
